angular.module('cpm').config(($routeProvider) => {
    'use strict';
    $routeProvider
        .when('/account/:accountId/:advertiserId/feed/:feedId', {
            controller: 'FeedCtrl as feed',
            templateUrl: 'feed/feed.html',
            role: 'ADMIN',
            title: 'Feed'
        })

        .when('/account/:accountId/:advertiserId/feed/:feedId/mapping', {
            controller: 'FeedRemapCtrl as remap',
            templateUrl: 'feed/feed-remap.html',
            role: 'ADMIN',
            title: 'Feed Mapping'
        })
});
